import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MarkdownModule, MarkdownService } from 'ngx-markdown';
import { terms_text } from '../../../_config/tos.json';

@Component({
  selector: 'app-tos-modal',
  standalone: true,
  imports: [MarkdownModule],
  templateUrl: './tos-modal.component.html',
  styleUrl: './tos-modal.component.scss'
})
export class TosModalComponent implements OnDestroy {
  @ViewChild('tosWrapper', { static: false }) tosWrapper!: ElementRef;

  public terms: string = '';
  public canAcceptTOS: boolean = false;
  public scrolledToTop = false;

  private readonly interval: any;

  constructor(
    protected activeModal: NgbActiveModal,
    private markdownService: MarkdownService,
  ) {
    // Parse the terms of Markdown service text from JSON and convert it to HTML
    this.terms = this.markdownService.parse(terms_text).toString();
    
    // Check if the user can accept the TOS by scrolling to the bottom
    this.interval = setInterval(() => {
      if (this.tosWrapper) {
        // Fix for mid-scroll on load
        if (!this.scrolledToTop) {
          this.tosWrapper.nativeElement.scrollTo(0,0);
          this.scrolledToTop = true;
        }
        if (!this.canAcceptTOS) {
          const scrollTop = this.tosWrapper.nativeElement.scrollTop;
          const scrollHeight = this.tosWrapper.nativeElement.scrollHeight;
          const clientHeight = this.tosWrapper.nativeElement.clientHeight;

          this.canAcceptTOS = Math.round(scrollTop + clientHeight) >= scrollHeight - 24;
        }
      } else {
        this.canAcceptTOS = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
